// ReportCard.js
// Component for Report Card

// Imports
import React from 'react';
import PropTypes from 'prop-types';
import { Box } from 'reflexbox';
import { Card } from '@blueprintjs/core';
import ReportActions from './ReportActions';

// Component Class
// Renders a report card template
class ReportCard extends React.Component {
  // Renders Component
  render() {
    return (
      <Box w={[1,1/2,1/3,1/4]} p={1}>
        <Card>
          <h5>{this.props.title}</h5>
          <p>{this.props.description}</p>
          {this.props.children}
          <ReportActions
            getFilename={this.props.getFilename}
            getReport={this.props.getReport}
            disabled={this.props.disabled}
          />
        </Card>
      </Box>
    );
  }
}

// Required Properties
ReportCard.propTypes = {
  title: PropTypes.string.isRequired,
  description: PropTypes.string.isRequired,
  disabled: PropTypes.bool,
  getReport: PropTypes.func.isRequired,
  getFilename: PropTypes.func.isRequired,
}

// Exports
export default ReportCard;


// WEBPACK FOOTER //
// ./src/components/ReportView/ReportCard.js